import React from 'react';
import { cva } from 'class-variance-authority';

const DAY_LABELS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

const dayBadge = cva(
  [
    'w-7 h-7 flex items-center justify-center font-medium text-sm border rounded-full',
  ],
  {
    variants: {
      status: {
        added: 'border-green-500 text-green-700 bg-green-50',
        removed: 'border-red-500 text-red-700 line-through bg-red-50',
        active: 'border-gray-400 text-gray-700',
        inactive: 'border-gray-300 text-gray-200',
      },
    },
  },
);

function getDayStatus(wasBefore, isAfter) {
  if (!wasBefore && isAfter) return 'added';
  if (wasBefore && !isAfter) return 'removed';
  if (wasBefore && isAfter) return 'active';
  return 'inactive';
}

export default function AvailableDaysDiff({ beforeValue, afterValue }) {
  const before = Array.isArray(beforeValue) ? beforeValue : [];
  const after = Array.isArray(afterValue) ? afterValue : [];

  return (
    <div className="py-1 flex space-x-1">
      {DAY_LABELS.map((label, index) => {
        const status = getDayStatus(
          Boolean(before[index]),
          Boolean(after[index]),
        );

        return (
          <span key={index} className={dayBadge({ status })}>
            {label}
          </span>
        );
      })}
    </div>
  );
}
